module.exports = __webpack_public_path__ + "static/media/light-ceiling.102f3548.svg";